<template>
   <!-- A hidden value sent with the form (record id, row id ...). Nothing is shown. -->
   <input type="hidden" v-bind="$attrs" :value="modelValue ?? ''" />
</template>

<script>
// <HiddenField v-model="formInputs.id" />
// name, required ... go to the <input>.
export default {
   name: "HiddenField",
   inheritAttrs: false,
   props: {
      modelValue: { default: "" },
   },
};
</script>